export const BODY_START_MARKER = "<!-- body start -->";
export const BODY_END_MARKER = "<!-- body end -->";

/**
 * For preview: replace #today# only. Variables like #employee.name# are left
 * as-is so the user sees them as placeholders in the iframe.
 */
export function buildPreviewHtml(htmlContent: string): string {
  return htmlContent
    .split("#today#")
    .join(new Date().toLocaleDateString("en-IN"));
}

/**
 * Inject inner body HTML into the wrapper template between the body markers.
 * If the wrapper already has the markers, insert there; otherwise wrap naively.
 */
export function injectIntoWrapper(
  wrapperHtml: string,
  bodyHtml: string
): string {
  const startIdx = wrapperHtml.indexOf(BODY_START_MARKER);
  const endIdx = wrapperHtml.indexOf(BODY_END_MARKER);
  if (startIdx !== -1 && endIdx !== -1) {
    return (
      wrapperHtml.substring(0, startIdx + BODY_START_MARKER.length) +
      bodyHtml +
      wrapperHtml.substring(endIdx)
    );
  }
  // fallback: just return the body
  return bodyHtml;
}
